/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.rpc.HubSpotVideoSearchRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const searchRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'search',
  auth: 'app',
  fingerprint: '_Cugkk3QoLmE1tRgQcKKN5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const advancedSearchRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'advancedSearch',
  auth: 'app',
  fingerprint: '0HQyoRzyjSDf83Gmf1482JwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const advancedSearchWithVideosHydratedRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'advancedSearchWithVideosHydrated',
  auth: 'app',
  fingerprint: '0HQyoRzyjSBwdEkA2LnQj5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEmbeddedVectorsForVideoRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'getEmbeddedVectorsForVideo',
  auth: 'app',
  fingerprint: 'ATWAZeIns-nRAJHdJKV2IJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const reprocessVideosForVisualSearchRpc = {
  serviceName: 'com.hubspot.video.rpc.HubSpotVideoSearchRpc',
  rpcName: 'reprocessVideosForVisualSearch',
  auth: 'app',
  fingerprint: 'M30cV0GJB7R4cOwYGhQuHZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};